class NewsletterModal extends ModalElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === "/challenge" || !theme.cookiesEnabled) {
      return;
    }

    if (!theme.config.isTouch || Shopify.designMode) {
      this.init();
    } else {
      new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
    }
  }

  get shouldLock() {
    return true;
  }

  get testMode() {
    return this.getAttribute("data-test-mode") === "true";
  }

  get delay() {
    return this.hasAttribute("data-delay")
      ? parseInt(this.getAttribute("data-delay"))
      : 5;
  }

  get expiry() {
    // Return session timeout in minutes (45 minutes default)
    return this.hasAttribute("data-expiry")
      ? parseInt(this.getAttribute("data-expiry"))
      : 45;
  }

  get cookieName() {
    return "concept:newsletter-popup-session";
  }

  get sessionStorageKey() {
    return "newsletter-popup-dismissed";
  }

  get submited() {
    return this.querySelector(".alert") !== null;
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    // Open modal if errors or success message exist
    if (this.submited) {
      this.load(1);
      return;
    }

    if (this.testMode || !this.isPopupDismissed()) {
      this.load(this.delay);
    }
  }

  load(delay) {
    if (Shopify.designMode) return;

    setTimeout(() => this.show(), delay * 1000);
  }

  afterShow() {
    super.afterShow();
    this.classList.add("show-image");
  }

  afterHide() {
    super.afterHide();
    this.classList.remove("show-image");

    // Remove session storage in case it was set in test mode
    if (this.testMode) {
      this.removeSessionDismissal();
      return;
    }

    this.setSessionDismissal();
  }

  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }

  // Session-based methods for newsletter popup
  isPopupDismissed() {
    try {
      const dismissedData = sessionStorage.getItem(this.sessionStorageKey);
      if (!dismissedData) return false;

      const data = JSON.parse(dismissedData);
      const now = Date.now();
      const timeoutMinutes = this.expiry;

      // Check if session has expired (timeout in minutes)
      if (now - data.timestamp > timeoutMinutes * 60 * 1000) {
        this.removeSessionDismissal();
        return false;
      }

      return true;
    } catch (e) {
      return false;
    }
  }

  setSessionDismissal() {
    try {
      const data = {
        dismissed: true,
        timestamp: Date.now(),
      };
      sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(data));
    } catch (e) {
      // Fallback to cookie if sessionStorage fails
      console.warn("SessionStorage not available, using fallback cookie");
      this.setCookie(this.cookieName, 1); // 1 day fallback
    }
  }

  removeSessionDismissal() {
    try {
      sessionStorage.removeItem(this.sessionStorageKey);
    } catch (e) {
      // Fallback to remove cookie
      this.removeCookie(this.cookieName);
    }
  }
}
customElements.define("newsletter-modal", NewsletterModal);
